import { MAX_ALGOLIA_PAGINATED_RESULTS } from "@/modules/jobSearch/constants/response"

export function getDisplayedTotalCount(totalCount: number): number {
  return totalCount > MAX_ALGOLIA_PAGINATED_RESULTS ? MAX_ALGOLIA_PAGINATED_RESULTS : totalCount
}
